import moment from 'moment';

require('moment/locale/pt-br.js');
moment.locale('pt-br');

export const momentMixin = {
    methods: {
        moment (date = new Date(), format) {
            return format ? moment(date, format) : moment(date);
        },
        formatDate (date = new Date(), format = 'L') {
            return moment(date).format(format);
        },
        toDate (date = new Date(), format = 'L') {
            return moment(date, format).toDate();
        }
    }
};



// WEBPACK FOOTER //
// ./src/modules/shared/mixins/moment.mixin.js